export const uiDownloadButton = {
    name: 'UI Download Button',
    description: '',
    displayField: 'text',
    fields: {
        text: {
            name: 'Text',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        mediaAsset: {
            name: 'Media Asset',
            type: 'Link',
            linkType: 'Asset',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    linkMimetypeGroup: [
                        'attachment',
                        'presentation',
                        'spreadsheet',
                        'pdfdocument',
                        'archive'
                    ]
                }
            ]
        },
        buttonTheme: {
            name: 'Button theme',
            type: 'Link',
            linkType: 'Entry',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['linkButtonTheme'] }]
        }
    }
};
//# sourceMappingURL=uiDownloadButton.js.map